module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-markup"
  }, [_c('div', {
    staticClass: "footer-markup__block footer-markup__block_logo"
  }, [(_vm.logo) ? _c('div', {
    staticClass: "footer-markup__logo"
  }, [_c('div', {
    staticClass: "footer-markup__logo-image",
    style: (("background-image: url(" + _vm.logo + ")"))
  })]) : _vm._e(), _c('div', {
    staticClass: "footer-markup__copyright"
  }, [_vm._v("Copyright " + _vm._s(_vm.currentYear))]), _c('div', {
    staticClass: "footer-markup__name"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._m(0)]), (_vm.$slots.alias) ? _c('div', {
    staticClass: "footer-markup__block footer-markup__block_alias"
  }, [_vm._t("alias")], 2) : _vm._e(), (!_vm.$slots.alias) ? _c('div', {
    staticClass: "footer-markup__block footer-markup__block_menu"
  }, [_vm._t("menu")], 2) : _vm._e(), (!_vm.$slots.alias) ? _c('div', {
    staticClass: "footer-markup__block footer-markup__block_firm"
  }, [_vm._t("info")], 2) : _vm._e(), _c('div', {
    staticClass: "footer-markup__block footer-markup__block_info"
  }, [_c('div', {
    staticClass: "footer-markup__phone"
  }, [_vm._t("phones")], 2), _c('div', {
    staticClass: "footer-markup__email"
  }, [_vm._t("emails")], 2), _c('div', [_vm._t("counter")], 2), _c('div', [_vm._t("socialNetworks")], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-markup__inlearno"
  }, [_c('div', [_vm._v("Реализовано на технологиях")]), _c('a', {
    staticClass: "footer-markup__inlearno-link",
    attrs: {
      "href": "https://inlearno.ru/?utm_source=navigator",
      "target": "_blank"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34096c9b","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/footer/Markup.vue
// module id = 8b17c640b642c3591701
// module chunks = 0